import { isNullOrUndefined } from 'util';
var formatMoney = require('../General/Helper').formatMoney;
var SiteEdit = require('./SiteEdit').SiteEdit;
var OrderListing = require('../Order/OrderListing').OrderListing;
var TemplateView = require('../Template/TemplateView').TemplateView;
import { AbconetApi } from '../General/AbconetApi';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactTooltip from 'react-tooltip';
import Select from "react-select";
import $ from "jquery";
var ScheduleListing = require('../Report/ReportScheduleListing').ReportScheduleListing;
var ScheduleSelector = require('../General/Selectors/ScheduleSelector').ScheduleSelector;
import ReactModal from "react-modal";
var EquipmentListing = require('../Equipment/EquipmentListing').EquipmentListing;

export class SiteView extends React.Component {

    constructor(props) {
        super(props);
        var canEdit = props.initialSite.canEdit;

        if (props.initialSite.id == 0) {
            canEdit = true;
        }
        this.state = {
            canEdit: canEdit,
            templateLoaded: false,
            cronText: '',
            scheduleModalOpen: false,
            isSaved: true,
            isSaving: false,
        }
    }


    componentDidMount() {
        this.loadTemplateCollection();
    }

    setEditMode() {
        if (this.props.onSetEditMode) {
            this.props.onSetEditMode();
        }
    }

    loadTemplateCollection() {
        $('#nav-loader-spinner').show();
        AbconetApi.get(`/api/address/${this.props.initialSite.id}/stocklist`).then((templateCollection) => {
            var templateOptions = [];
            templateCollection.forEach(function (template) {
                var option = { 'id': template.id, 'name': template.name };
                templateOptions.push(option);
            });

            if (templateCollection.length > 0) {
                this.setState({ templateCollection, templateOptions, selectedTemplate: templateCollection[0], selectedTemplateId: templateCollection[0].id, templateLoaded: true });
                this.loadTemplateSchedule(templateCollection[0].id);
            } else {
                this.setState({ templateLoaded: true });
            }
        });
    }

    renderEditButton() {
        if (this.state.canEdit) {
            return <button className="btn btn-primary float-right btn-edit-template" onClick={this.setEditMode.bind(this)}>Edit</button>;
        }
    }

    updateselectedTemplate(ev) {
        var index = this.state.templateCollection.findIndex(x => x.id == ev.id);
        this.setState({ selectedTemplateId: ev.id, selectedTemplate: this.state.templateCollection[index] });

        this.loadTemplateSchedule(ev.id);
    }

    loadTemplateSelector() {
        var templateSelection;
        if (this.state.templateCollection != null && this.state.templateCollection.length > 1) {
            templateSelection = <Select className="select-inline type-month"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                options={this.state.templateOptions}
                value={this.state.templateOptions.find(x => x.id == this.state.selectedTemplateId)}
                onChange={this.updateselectedTemplate.bind(this)}
            />;
        }

        return templateSelection;
    }

    renderTemplatePanel() {
        var templateTabPanel;
        if (this.state.templateCollection != null && this.state.templateCollection.length > 0) {
            templateTabPanel = <TemplateView
                initialTemplate={this.state.selectedTemplate}
                limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                limitToSite={true}
            />;
        } else if (this.state.templateLoaded && this.state.templateCollection == null) {
            templateTabPanel = <div>
                No results.
            </div>
        }

        return <div className="template-tab">
            {this.loadTemplateSelector()}
            {templateTabPanel}
        </div>
    }

    loadTemplateSchedule(id) {
        if (isNullOrUndefined(id)) {
            return;
        }

        $('#nav-loader-spinner').show();
        AbconetApi.get(`/api/address/${this.props.initialSite.id}/templateschedule`).then((templateScheduleListing) => {
            this.setState({ templateScheduleListing: templateScheduleListing });
        });
    }

    updateTemplateScheduleListing(ev) {
        this.loadTemplateSchedule(this.state.selectedTemplateId);
    }

    renderCreateScheduleButton() {
        var btnText = 'Save';
        var btnClass = 'changes';
        if (this.state.isSaved) {
            btnText = 'Saved';
            btnClass = 'saved';
        }
        if (this.state.isSaving) {
            btnText = 'Saving';
            btnClass = 'saving';
        }

        if (isNullOrUndefined(this.state.cronText)) {
            btnText = 'Save';
        }

        return <button className={"btn btn-primary float-right " + btnClass} disabled={this.state.isSaved || this.state.isSaving} onClick={this.createTemplateSchedule.bind(this)}>{btnText}</button>;

    }

    createTemplateSchedule() {
        var self = this;


        var templateScheduleDto = {
            expression: this.state.cronText,
            siteId: this.props.initialSite.id,
            templateId: this.state.selectedTemplateId,
        };

        this.setState({ isSaving: true });

        fetch('/api/address/schedule', {
            method: 'POST',
            body: JSON.stringify(templateScheduleDto),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (response) {
            setTimeout(
                () => {
                    self.setState({ isSaved: true, isSaving: false });
                    self.loadTemplateSchedule(self.state.selectedTemplateId);

                    setTimeout(() => {
                        self.closeScheduleModal();
                    },
                        300);
                },
                200);
        });
    }

    
    updateSchedule(cron) {
        this.setState({
            cronText: cron
        });

        if (isNullOrUndefined(cron)) {
            this.setState({
                isSaved: true
            });
        } else {
            this.setState({
                isSaved: false
            });
        }

    }

    openScheduleModal(ev) {
        ev.preventDefault();
        this.setState({
            scheduleModalOpen: true
        });
    }

    closeScheduleModal() {
        this.setState({
            scheduleModalOpen: false
        });
    }

    renderOpenScheduleButton() {
        if (this.state.canEdit || this.props.canCreateRecurringOrders) {
            return <a href="#" className="btn btn-primary" onClick={this.openScheduleModal.bind(this)}>Create Schedule</a>;
        }

        return <div className="recurring-schedule-message text-left"> Sorry, you do not have permission to create a recurring order. </div>;
    }

    renderRecurringPanel() {
        var templateLabel = "Template Name";

        var templateSelector = this.loadTemplateSelector();
        if (isNullOrUndefined(templateSelector) && this.state.selectedTemplate != null) {
            templateSelector = <div className="card card-body bg-light pl-2">
                <span> <strong> {templateLabel}</strong>: {this.state.selectedTemplate.name}  </span>
            </div>;

            templateLabel = "";
        }


        if (isNullOrUndefined(this.state.selectedTemplateId) && this.state.templateLoaded) {
            if (this.state.canEdit || this.state.canCreateRecurringOrders) {
                return <div className="recurring-tab-info">
                    You need to have a template linked to this site before you can create a recurring order.
                </div>;
            }
        }

        return <div className="recurring-tab" key={'recurring-tab-' + this.state.selectedTemplateId}>
            <div className="col-12 text-right">
                <br />
                {this.renderOpenScheduleButton()}
            </div>

            <ReactModal isOpen={this.state.scheduleModalOpen} onRequestClose={this.closeScheduleModal.bind(this)} portalClassName="modal-portal" className="modal-dialog schedule-modal" overlayClassName="modal" bodyOpenClassName="modal-open" >
                <div className="modal-content">
                    <div className="bd p-15">
                        <h5 className="m-0">Create Schedule</h5>
                        <hr />
                    </div>
                    <div className="pl-2 ml-1">
                        {templateLabel}{templateSelector}
                    </div>
                    <div className="modal-body">
                        <ScheduleSelector onChange={this.updateSchedule.bind(this)} />
                        <div>
                            {this.renderCreateScheduleButton()}
                        </div>
                    </div>
                    <button onClick={this.closeScheduleModal.bind(this)} className="close"><span aria-hidden="true">&times;</span></button>
                </div>
            </ReactModal>

            <div className="col-12">
                <ScheduleListing
                    templateScheduleListing={this.state.templateScheduleListing}
                    isTemplateScheduleListing={true}
                    siteId={this.props.initialSite.id}
                    updateTemplateScheduleList={this.updateTemplateScheduleListing.bind(this)}
                    canEdit={this.state.canEdit}
                    canCreateRecurringOrders={this.props.canCreateRecurringOrders}
                />
            </div>
        </div>
    }


    render() {
        var address = this.props.initialSite;
        var budgetText = "-";
        if (!address.hideBudget && address.monthlyBudget > 0) {
            budgetText = address.monthlyBudget;
        }
        var siteSuperVisorText = "-";
        if (address.siteSupervisor != null) {
            siteSuperVisorText = address.siteSupervisor.displayName
        }
        var referenceText = "-";
        if (address.customerReference != null) {
            referenceText = address.customerReference;
        }

        var deliveryInstruction = "-";
        if (address.note != null) {
            deliveryInstruction = address.note
        }

        var showEquipment = address.canViewEquipment;

        return (

            <div>
                <div className="card card-body bg-light">
                    {this.renderEditButton()}
                    <h4>{address.name}</h4>
                    <div className="row">
                        <div className="col-5">
                            <div className="row">
                                <div className="col-6"><strong>Budget (monthly):</strong></div><div className="col-6">{budgetText}</div>
                                <div className="col-6"><strong>Supervisor:</strong></div><div className="col-6">{siteSuperVisorText}</div>
                                <div className="col-6">
                                    <strong>
                                        <i className="icon icon-info lead text-primary" data-tip='Your Site Code Reference'></i> Your reference:
                                    </strong>
                                    <ReactTooltip />
                                </div><div className="col-6">{referenceText}</div>
                            </div>

                        </div>
                        <div className="col-7">
                            <strong>Delivery instructions:</strong><br />
                            <p>{deliveryInstruction}</p>
                        </div>
                    </div>
                </div>



                <Tabs className="icon-tabs">
                    <TabList>
                        <Tab><i className="icon icon-order lead"></i>Templates</Tab>
                        <Tab><i className="icon icon-order lead"></i>Order History</Tab>
                        <Tab><i className="icon icon-order lead"></i>Recurring order</Tab>
                        {showEquipment && <Tab><i className="icon icon-order lead"></i>Equipment</Tab>}
                    </TabList>
                    <TabPanel key={'template-edit-panel-' + this.state.selectedTemplateId}>
                        {this.renderTemplatePanel()}
                    </TabPanel>
                    <TabPanel key="order-listing-panel">
                        <OrderListing limitToSite={address} />
                    </TabPanel>
                    <TabPanel key={'recurring-panel-' + this.state.selectedTemplateId}>
                        <p>
                            {this.renderRecurringPanel()}
                        </p>
                    </TabPanel>
                    {showEquipment && <TabPanel key="equipment-listing-panel">
                        <EquipmentListing limitToSite={address} />
                    </TabPanel>}
                </Tabs>
                <br />
                <a href="/sites" className="btn btn-outline-primary">View all sites</a>
            </div>
        );
    }

}